import React from "react";
import {Avatar, Divider, ListItem, ListItemAvatar, ListItemText} from "@material-ui/core";
import Image from "material-ui-image/lib/components/Image/Image";
import PersonIcon from "@material-ui/icons/Person";
import styled from "styled-components";

const PersonAvatar = styled(Avatar)`
  background-color: #046A38 !important;
`;

const ContactListItem = (props: any) => {
    const {img, name, title} = props

    return (
        <>
            <ListItem
                disableGutters
            >
                <Image
                    src={img}
                    disableSpinner={true}
                    imageStyle={{borderRadius: 8, width: '100%'}}
                    style={{width: '100%'}}
                />
            </ListItem>
            <ListItem
                disableGutters
            >
                <ListItemAvatar>
                    <PersonAvatar>
                        <PersonIcon />
                    </PersonAvatar>
                </ListItemAvatar>
                <ListItemText
                    primary={name}
                    secondary={title}
                />
            </ListItem>
            <Divider variant={'middle'} component={'li'} />
        </>
    );
};

export default ContactListItem;